import axios from "axios";
import { toast } from "react-toastify";

axios.interceptors.response.use(null, (error) => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status < 500;

  if (!expectedError) {
    //log error
    toast("Service Is Temporarily Unavailable");
  }
  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["x-auth-token"] = jwt;
}

function getApiUrl() {
  if (process.env.REACT_APP_ENV === "production") {
    return "https://api.smartciti.com.ng:4000/1.0";
  } else if (process.env.REACT_APP_ENV === "staging") {
    return "https://staging.smartciti.com.ng/1.0";
  } else {
    return "http://localhost:4000/1.0";
  }
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  getApiUrl,
};
